import { Typography, Box, SxProps } from '@mui/material'
import React, { FC } from 'react'
import { makeStyles } from 'tss-react/mui'
import { J2Caution } from '@e3dc-react/icons'

const useStyles = makeStyles()(theme => ({
  card: {
    width: '100%',
    background: theme.palette.grey.grey07,
    border: `1px solid ${theme.palette.grey.grey06}`,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
  },
  text: {
    textAlign: 'center',
  },
}))

interface WarningMessageProps {
  text: string
  className?: string
  sx?: SxProps
}

/** Warning banner with generic text */
const WarningMessage: FC<WarningMessageProps> = ({ text, className, sx }) => {
  const { classes, cx } = useStyles()

  return (
    <Box className={cx(classes.card, className)} sx={sx}>
      <J2Caution color="error" />
      <Typography variant="caption" className={classes.text}>
        {text}
      </Typography>
    </Box>
  )
}

export default WarningMessage
